export default __webpack_public_path__ + "static/media/Iziel's Hate.975fce25.jpg";